export default __webpack_public_path__ + "static/media/error-connect.6ede6a45.svg";